/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import DataTable from "react-data-table-component";
import { useHistory } from "react-router-dom";
import { ReassingnCompliance } from "../modals";
import { openlightbox } from "../../util/Functions";
import { RecentActorsOutlined, Cancel, Edit, ExpandMore, AddTask, Save, Search } from "@mui/icons-material";
import { Box, MenuItem, Checkbox, Accordion, AccordionDetails, AccordionSummary, IconButton, TextField, Tooltip, Tabs, Tab, Switch } from "@mui/material";
import { FlexGrid, Card, Typography, Button } from "@albo-ui/core";
import { theme, customStyles, customStyles3 } from "../../util/TableStyles"
import { noDataComponent } from "../../util/DataObject"
import { ThemeProvider } from "@mui/material/styles";
import { compliancePriority } from "../../util/DataObject";
import moment from "moment";
import "moment/locale/es";

const ComplianceReport = (props) => {
	moment.locale("es");

	const history = useHistory();
	const [clear, setClear] = useState(false);
	const [agent, setAgent] = useState('');
	const [total, setTotal] = useState(0);
	const [data, setData] = useState([]);
	const [agents, setAgents] = useState([]);
	const [disabled, setDisabled] = useState(true);
	const [expanded, setExpanded] = useState(false);
	const [tabActive, setTabActive] = useState('AGENTS');
	
	const maxRegAgents = 50;
	const [maxReg, setMaxReg] = useState(30);
	const [maxAssign, setMaxAssign] = useState(0);
	const [configAgent, setConfigAgent] = useState([]);
	const [pagesAgents, setPagesAgents] = useState(0);
	const [errorAssign, setErrorAssign] = useState(false);
	
	const [startDate, setStartDate] = useState(props.content.startDate);
	const [endDate, setEndDate] = useState(props.content.endDate);

	const [state, setState] = React.useState({});
	const [unassigned, setUnassigned] = useState(0);
	const [asignados, setAsignados] = useState(0);
	const [revisados, setRevisados] = useState(0);
	const quantity = [
		{ title: "Asignados: ", data: tabActive === "AGENTS" ? asignados : total },
		{ title: "No asignados: ", data: unassigned },
	];
	const tabs = [
		{ name: "AGENTS",	title: "Agentes"},
		{ name: "CUSTOMERS",	title: "Validaciones pendientes"}
	];
	
	if(tabActive === "AGENTS"){
		quantity.unshift({ title: "Revisados: ", data: revisados })
	} else {
		quantity["title"] === "Revisados: " && quantity.shift()
	}

	useEffect(() => {
		init();
	}, [props.content]);

	const init = () => {
		setDisabled(true);
		if (props.content.type == "agents") {
			setTabActive("AGENTS");
		}
		if (props.content.type == "customers") {
			setTabActive("CUSTOMERS");
		}

		let a = 0;
		let r = 0;
		let u = 0;
		if (props.content.type == "agents") {
			for (let i = 0; i < props.content.data.length; i++) {
				a += props.content.data[i]["totalAssigned"];
				r +=
				props.content.data[i]["totalRejected"] +
				props.content.data[i]["totalValidated"] +
				props.content.data[i]["totalInvalidated"];
			}
			if (props.content.hasOwnProperty("data")) {
				let d = [];
				for (let i = 0; i < maxRegAgents; i++) {
					if (props.content.data[i]) {
						d.push(props.content.data[i]);
					}
				}
				let pagesAux = Math.floor(props.content.data.length / maxRegAgents);
				if (pagesAgents < props.content.data.length / maxRegAgents) {
					pagesAux += 1;
				}
				setPagesAgents(pagesAux);
				setData(JSON.parse(JSON.stringify(d)));
				if (props.content.hasOwnProperty("oldAgents")) {
					setAgents(JSON.parse(JSON.stringify(props.content.oldAgents)));
				} else {
					setAgents(JSON.parse(JSON.stringify(props.content.data)));
				}
			}
		}

		if (props.content.type == "customers") {
			if (props.content.hasOwnProperty("customers")) {
				setData(JSON.parse(JSON.stringify(props.content.customers)));
			}
			if (props.content.hasOwnProperty("agents")) {
				setAgents(JSON.parse(JSON.stringify(props.content.agents)));
			}
			if (props.content.hasOwnProperty("agent")) {
				setAgent(props.content.agent);
			}
		}

		if (props.content.hasOwnProperty("limit")) {
			setMaxReg(props.content.limit);
		}
		if (props.content.hasOwnProperty("total")) {
			setTotal(props.content.total);
		}
		if (props.content.hasOwnProperty("unassigned")) {
			u = props.content.unassigned;
		}

		setUnassigned(u);
		setAsignados(a);
		setRevisados(r);
	};

	const isWithinOneMonth = (startDate: string | Date, endDate: string | Date): boolean => {
		const start = new Date(startDate);
		const end = new Date(endDate);
	
		const oneMonthLater = new Date(start);
		oneMonthLater.setMonth(start.getMonth() + 1);
		oneMonthLater.setDate(oneMonthLater.getDate() + 1);
	
		return end <= oneMonthLater;
	};

	let requestReport = async (data) => {
		if (data["type"] === "agents" && !isWithinOneMonth(data["startDate"], data["endDate"])) {
			return props.changeAlert(true, 'error', 'El rango de búsqueda permitido es un mes.');
		}

		props.changeLoader(true);
		let request = await API.service("complianceReport", data, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status === 200 && request.data.data.response === "OK") {
			if (data["agent_uuid"]) {
				request.data.data.widget[0].content["oldAgents"] = agents;
			}
			props.changeWidgets(request.data.data.widget);
		}
		props.changeLoader(false);
	};

	const reassign = async (customers, agent_uuid, close) => {
		let t = close;
		props.changeLoader(true);
		let req = {
			agent_uuid: agent_uuid,
			customers: customers,
		};
		let request = await API.service("reassignCompliance", req, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status === 200 && request.data.data.response === "OK") {
			t();
			findCustomerAssign('', 1);
		}
		props.changeLoader(false);
	};

	const updateMaxAssign = async (uuid) => {
		props.changeLoader(true);
		let data = {
			maxAssign: maxAssign,
			uuid: uuid,
			prop: 'maxAssignedCompliance'
		}

		let request = await API.service('updateMaxAssign', data, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status == 200 &&  request.data.data.response == "OK" ) {
			await findAgentsFilter();
			props.changeAlert(true, 'success', 'Número de asignaciones actualizada con éxito.');
		}
		props.changeLoader(false);
	};


	const findAgentsFilter = async () => {
		props.changeLoader(true);
		let data = {
			roles: 'inext-role-compliance-analyst',
			status: ['enable', 'enabled']
		}

		let request = await API.service('findAgentsFilter', data, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status == 200 &&  request.data.data.response == "OK" ) {
			let agentsCompliance = request.data.data.content;
			setConfigAgent(JSON.parse(JSON.stringify(agentsCompliance)));
		}
		props.changeLoader(false);
	};

	const findCustomerAssign = async (customer, pageCurrent) => {
		let data = {
			type: "customers",
			page: pageCurrent,
			limit: maxReg,
			agent_uuid: customer ? customer : '',
		};
		requestReport(data);
	};

	const handlePageChange = async (page) => {
		let data = {
			type: tabActive == 'CUSTOMERS' ? 'customers' : 'agents',
			page: page,
			limit: maxReg,
			agent_uuid: agent,
		};
		requestReport(data);
	};

	const changeTotal = async (e) => {
		let data = {
			type: tabActive == 'CUSTOMERS' ? 'customers' : 'agents',
			page: 1,
			limit: e,
			agent_uuid: agent,
		};
		requestReport(data);
	};

	const changeTab = async (tab) => {
		if (tabActive == tab) {
			return;
		}
		if (tab == "AGENTS") {
			setClear(true);
			setAgent('');
			let data = {
				type: "agents",
				startDate: startDate,
				endDate: endDate,
			};
			requestReport(data);
		}
		if (tab == "CUSTOMERS") {
			setClear(false);			
			setAgent('');
			findCustomerAssign('', 1);
			setEndDate(props.content.endDate);
			setStartDate(props.content.startDate);
		}
	};
	
	const changeAgent = async (e) => {
		let value = ''
		if(e.target.value === -1){
			setAgent('');
		} else {
			setAgent(e.target.value);
			value = e.target.value
		}
		if (tabActive == "CUSTOMERS") {
			findCustomerAssign(value, 1);
		}
		if (tabActive == "AGENTS") {
			let data = {
				agent_uuid: value,
				startDate: startDate,
				endDate: endDate,
				type: "agents"
			};
			requestReport(data);
		}
	};

	const test = (data) => {
		if(tabActive === "CUSTOMERS" && props.config?.actions?.indexOf("reassign") > -1){
			if (data.selectedCount > 0) {
				const s = [];
				for (let i = 0; i < data.selectedRows.length; i++) {
					s.push(data.selectedRows[i]);
				}
				setState(s);
				setDisabled(false);
			} else {
				setDisabled(true);
			}

		}
	};

	const openModal = (dataSelect) => {
		let contentModal = {
			title: "Reasignar Clientes",
			agents: agents,
			customers: dataSelect,
		};
		const as = <ReassingnCompliance
			pos={props.pos}
			changeAlert={props.changeAlert}
			changeLoader={props.changeLoader}
			contentModal={contentModal}
			reassign={reassign}
			key="cardCancelW"
		/>
		openlightbox(as);
	};

	const changeMaxAssign = (e) => {
		let value = e.target.value
		setMaxAssign(value);
		if(value > maxReg){
			setErrorAssign(true);
		} else {
			setErrorAssign(false);
		}
	};

	const closeForm = (item) => {
		let conf = configAgent;
		for(let i = 0; i<conf.length; i++){
			if(conf[i]['uuid'] == item['uuid']){
				conf[i]['edit'] = false;
			}
		}

		setConfigAgent(JSON.parse(JSON.stringify(conf)));
	};

	const formMaxAssigned = (item) => {
		let conf = configAgent;
		let max = maxAssign;
		for(let i = 0; i<conf.length; i++){
			if(conf[i]['uuid'] == item['uuid']){
				conf[i]['edit'] = true;
				max = item['maxAssigned'];
			}else{
				conf[i]['edit'] = false;
			}
		}
		setMaxAssign(max);
		setConfigAgent(JSON.parse(JSON.stringify(conf)));
	};

	const updateStatus = async (item) => {
		props.changeLoader(true);
		let data = {
			uuid: item.uuid,
			prop: 'statusCompliance',
			value: item["statusCompliance"] ? false : true
		}

		let request = await API.service('complianceStatus', data, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status == 200 &&  request.data.data.response == "OK" ) {
			await findAgentsFilter();
			if(!data.value){
				let list = {
					type: tabActive == 'CUSTOMERS' ? 'customers' : 'agents',
					page: 1,
					limit: maxReg,
					agent_uuid: agent,
				};
				await requestReport(list);
			}
			props.changeAlert(true, 'success', 'Estatus actualizado con éxito.');
		}
		props.changeLoader(false);

	}

	const changeDayInit = (e) => {
		let start = moment(e.target.value).tz("America/Mexico_City").toJSON();
		setStartDate(start);
	};

	const changeDayEnd = async (e) => {
		let timeZoneEnd = moment(e.target.value).tz('America/Mexico_City').toJSON();
		setEndDate(timeZoneEnd);
	};

	const dateFilter = () => {
		let data = {
			startDate: startDate,
			endDate: endDate
		};
		if(agent){
			data['agent_uuid'] = agent;
		}
		if(tabActive == "AGENTS"){
			data["type"] = "agents";
		}
		return requestReport(data);
	};

	const changeExpanded = async (e, flag) => {
		if(flag){
			await findAgentsFilter();
		}else{
			setConfigAgent([]);
		}
		setExpanded(flag);
	};

	const disabledFunc = () => {
		let data = {};
	}

	function findActiveTab(item) { 
        return item.name === tabActive;
    }

	const paginationComponentOptions = {
		rowsPerPageText: 'Registros por página',
		rangeSeparatorText: "de",
	};
	const columnsAgents = [
		{ selector: (row) => row.name, name: "Nombre de agente", width:"19%", wrap: true, sortable: true, },
		{ selector: (row) => row.email, name: "Email", width:"19%", wrap: true, sortable: true },
		{ selector: (row) => row.totalAssigned, name: "No. Asignaciones", width:"16%", sortable: true },
		{ selector: (row) => row.totalRejected, name: "No. rechazos", width:"13%", sortable: true },
		{ selector: (row) => row.totalValidated, name: "No. validaciones", width:"15%", sortable: true },
		{ selector: (row) => row.totalInvalidated, name: "Solicitar documentos", width:"18%", sortable: true },
	];
	const columnsCustomer = [
		{ selector: (row) => row.customer?.name, name: "Nombre de cliente",  width: "18%", wrap: true, sortable: true, },
		{ selector: (row) => row.customer?.email, name: "Email",  width: "18%", wrap: true, sortable: true },
		{ selector: (row) => row.customer?.risk_level, name: "Nivel Riesgo", width: "8%", sortable: true },
		{ selector: (row) => compliancePriority.map((item) => item.key === row.priority ? item.label : null), name: "Prioridad", width: "10%", sortable: true },
		{ selector: (row) => row.agent?.name, name: "Agente", sortable: true },
		{ selector: (row) => row.adate ? moment(row.adate).format('L, H:mm') : '', name: "Fecha asignación", sortable: true },
		{ selector: (row) => row.cdate ? moment(row.cdate).format('L, H:mm') : '', name: "Fecha ingreso", sortable: true },
	];
	const columnsAgentsConfig = [
		{ selector: (row) => row.name, name: "Nombre de agente", width:"30%", wrap: true, sortable: true },
		{ selector: (row) => row.email, name: "Email", width:"30%", wrap: true, sortable: true },
		{ cell: (item) => {
				return <>
					{ !item.edit && <span>{item.maxAssigned}</span> }
					{ item.edit &&
						<TextField variant="standard" type="number" size="small" value={maxAssign} onChange={changeMaxAssign.bind(this)} error={errorAssign} helperText={errorAssign && `Cantidad permitida: ${maxReg}`} />
					}
				</>
			},
			name: "Máximo número de asignaciones", sortable: true, wrap: true, width:"15%",
		},
		{ cell: (item) => {
			  	return <div>
					{ !item.edit &&
						<Tooltip title="Cambiar número maximo de asignaciones">
							<IconButton onClick={formMaxAssigned.bind(this, item)}><Edit/></IconButton>
						</Tooltip>
					}
					{ item.edit &&
						<>
							<Tooltip title="Guardar">
								<span>
									
								<IconButton disabled={maxAssign.toString().length == 0 || maxAssign < 0 || maxAssign > maxReg ? true : false} onClick={updateMaxAssign.bind(this, item.uuid)}>
									<Save/>
								</IconButton>
								</span>
							</Tooltip>
							<Tooltip title="Cancelar">
								<IconButton onClick={closeForm.bind(this, item)}>
									<Cancel/>
								</IconButton>
							</Tooltip>
						</>
					}
				</div>
			},
			name: 'Acciones', sortable: true, maxWidth: "15%"
		},
		{ cell: (row) => {
			return <Switch checked={row.statusCompliance} onChange={updateStatus.bind(this, row)} color='secondary'/>
			}, name: 'Estatus', width:'10%', wrap: true, sortable: true, center: true
		},
	];

	return (
		<>
		{ props.config?.actions?.indexOf('edit') > -1 &&
			<Accordion sx={{width: '100% !important', mb: 2}} expanded={expanded} onChange={changeExpanded}>
				<AccordionSummary aria-controls="list-agents" id="list-agents-compliance-analyst" expandIcon={<ExpandMore/>} sx={{mx: 2.3}}>
					<Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
                        <RecentActorsOutlined sx={{ marginRight: 1 }}/> Analistas de cumplimiento
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<FlexGrid container direction="column">
						<ThemeProvider theme={theme}>
							<DataTable
								columns={columnsAgentsConfig}
								data={configAgent}
								customStyles={customStyles3}
								noDataComponent={noDataComponent} 
								fixedHeader
							/>
						</ThemeProvider>
					</FlexGrid>	
				</AccordionDetails>
			</Accordion>
		}

		<Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: theme.palette.grey}}> 
            <FlexGrid container fullWidth justify="space-between">
                <FlexGrid item>
                    <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
                        <AddTask sx={{ marginRight: 1 }}/> Operación de Compliance
					</Typography>
                </FlexGrid>
            </FlexGrid>

			<Box display={'flex'} py={4} justifyContent={'space-between'}>
				<FlexGrid container spacing={2} >
					<TextField select value={agent || -1} onChange={changeAgent.bind(this)} sx={{width: 250}} size='small' color='secondary' fullWidth>
						<MenuItem value={-1}>Agente</MenuItem>
						{agents.map((item) => (
							<MenuItem key={`agent-${item.uuid}`} value={item.uuid}>{item.name}</MenuItem>
						))}
					</TextField>
					{tabActive === "AGENTS" &&
						<FlexGrid container spacing={1}>
						<FlexGrid item>
							<TextField
								value={startDate.slice(0,10)}
								onChange={changeDayInit.bind(this)}
								label="Fecha inicio"
								size="small"
								type={"date"}
								InputLabelProps={{ shrink: true }}
								InputProps={{style: {height: 40}}} 
							/>
						</FlexGrid>
						<FlexGrid item>
							<TextField
								value={endDate.slice(0,10)}
								onChange={changeDayEnd.bind(this)}
								label="Fecha fin"
								size="small"
								type={"date"}
								InputLabelProps={{ shrink: true }}
								InputProps={{style: {height: 40}}} 
							/>
						</FlexGrid>
                        <IconButton onClick={dateFilter.bind(this)} sx={{padding: '0 !important'}}><Search sx={{padding: '7px', borderRadius: 2, boxSizing: 'content-box', color: 'white', backgroundColor: '#8bc179' }}/></IconButton>
						</FlexGrid>
					}
					{(tabActive === "CUSTOMERS" && props.config?.actions?.indexOf("reassign") > -1) && 
						<Button disabled={disabled} onClick={() => openModal(state)} style={{width: 150, height: 40}}>Reasignar</Button>
					}
				</FlexGrid>

				<FlexGrid container spacing={2}>
					{quantity.map((item) => {
						return <Card key={item.title} width={'auto'} padding={1} height='auto' alignItems='center'>
							<Typography variant='paragraph'>{item.title}</Typography>
							<Typography variant='smallTitle' style={{marginLeft: 10}}>{item.data}</Typography>
						</Card>
					})}
				</FlexGrid>
			</Box>


            <Box sx={{ borderBottom: 1, borderColor: 'divider' }} mb={2} >
              <Tabs value={tabs.findIndex(findActiveTab)} indicatorColor='secondary' textColor='secondary' centered >
                {tabs.map((item, index) => {
                  return <Tab key={index} label={item.title} onClick={changeTab.bind(this, item.name)} sx={{margin: 'auto', textTransform: 'none', fontWeight: 700, fontFamily: "Muli,sans-serif", fontSize: 18}} />
                })}
              </Tabs>
            </Box>

            <FlexGrid container style={{margin: '25px 0' }} direction="column">
                {
					<DataTable
						columns={tabActive === "CUSTOMERS" ? columnsCustomer : columnsAgents}
						data={data}
						customStyles={customStyles}
						onChangePage={tabActive == 'CUSTOMERS' ? handlePageChange : disabledFunc}
						onChangeRowsPerPage={tabActive === 'CUSTOMERS' ? changeTotal : null}
						pagination={tabActive === 'CUSTOMERS' ? true : false}
						paginationServer={tabActive === 'CUSTOMERS' ? true : false}
						paginationPerPage={50}
						paginationRowsPerPageOptions={[10,20,30,40,50]}
						paginationDefaultPage={props.content.page}
						paginationComponentOptions={paginationComponentOptions}
						paginationTotalRows={total}
						selectableRows={tabActive === "CUSTOMERS" && props.config?.actions?.indexOf("reassign") > -1 ? true : false}
						selectableRowsComponent={Checkbox}
						onSelectedRowsChange={test}
						clearSelectedRows={clear}
						noDataComponent={noDataComponent} 
					/>
                }
            </FlexGrid>
        </Card>
		</>
    )
};

export default ComplianceReport;